import { Helmet } from "react-helmet-async"
import {
	MailThreadDetails,
	TMailIntegration,
} from "../../../../../../../Integrations"
import { useOutletContext } from "react-router"
import { useParams } from "../../../../../../../router-utils"
import { TSearchParams, useSearch } from "@sembark-travel/ui-list"

export default function MailIntegrationThreadPage() {
	const context = useOutletContext<{ integration: TMailIntegration }>()
	const { folder, threadId } = useParams(
		"/integrations/:integrationId/mail/:folder/threads/:threadId"
	)
	const [params] = useSearch<
		TSearchParams & { mailbox: string | number | undefined }
	>()

	if (folder !== "inbox") {
		return null
	}

	return (
		<>
			<Helmet>
				<title>Thread | Integration</title>
			</Helmet>
			<MailThreadDetails
				integration={context.integration}
				threadId={threadId}
				mailboxId={params.mailbox}
			/>
		</>
	)
}
